import React from 'react';

import Carousel from 'react-material-ui-carousel'

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
  title: {
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(3),
  },
  sponsor: {
    textTransform: 'uppercase',
    fontWeight: 400,
    marginBottom: theme.spacing(1),
  },
  image: {
    width: '100%',
    height: 'auto'
  },
  carousel: {
    minHeight: '580px'
  },
  paper: {
    border: '1px solid #eee'
  }  
}));

const Sponsor = (props) => {
  const classes = useStyles();
  return (
    <>
      { props.config &&
        <Paper className={classes.paper}>
          < img src={props.config.imageUrl} alt={props.config.imageAlt} className={classes.image} />
        </Paper>
      }
    </>
  );
};

const GoldSponsors = (props) => {
  const classes = useStyles();
  return (
    <>
      { props.config &&
        <>
          <h4 className={classes.sponsor}>{props.config.title}</h4>
          <Grid container direction="row" spacing={3}>
            {props.config.logos.map((sponsor, index) => (
              <Grid item xs={6} sm={3} key={index}>
                <Sponsor config={sponsor} />
              </Grid>
            ))}
          </Grid>
        </>
      }
    </>
  );
};

const SignatureSponsors = (props) => {
  const classes = useStyles();
  return (
    <>
      { props.config &&
        <>
          <h4 className={classes.sponsor}>{props.config.title}</h4>
          <Grid container direction="row" spacing={3}>
            {props.config.logos.map((sponsor, index) => (
              <Grid item xs={12} key={index}>
                <Sponsor config={sponsor} />
              </Grid>
            ))}
          </Grid>
        </>
      }
    </>
  );
};

const PlatinumSponsors = (props) => {
  const classes = useStyles();
  return (
    <>
      { props.config &&
        <>
          <h4 className={classes.sponsor}>{props.config.title}</h4>
          <Grid container direction="row" spacing={3}>
            {props.config.logos.map((sponsor, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Sponsor config={sponsor} />
              </Grid>
            ))}
          </Grid>
        </>
      }
    </>
  );
};

const Slide1 = (props) => {
  const platinum = props.config && props.config.length  >= 1 ? props.config[0] : [];
  const signature = props.config && props.config.length  >= 2 ? props.config[1] : [];
  return (
    <Grid container direction="row" spacing={3}>
    <Grid item xs={12} md={9}>
      <PlatinumSponsors config={platinum} />
    </Grid>
    <Grid item xs={12} md={3}>
      <SignatureSponsors config={signature} />
    </Grid>
  </Grid>
  );
};

const Slide2 = (props) => {
  const gold = props.config && props.config.length  >= 3 ? props.config[2] : [];
  return (
    <Grid container direction="row" spacing={3}>
    <Grid item xs={12}>
      <GoldSponsors config={gold} />
    </Grid>
  </Grid>
  );
};

export default (props) => {
  const classes = useStyles();
  return (
    <>
      { props.config && props.config.length === 3 &&
        <div className={classes.root}>
          <Container>
            <h3 className={classes.title}>With Thanks to our Sponsors</h3>
            <Carousel animation='fade' interval={5000} timeout={1000}>
              <div className={classes.carousel}><Slide1 config={props.config} /></div>
              <div className={classes.carousel}><Slide2 config={props.config} /></div>
            </Carousel>
          </Container>
        </div>
      }
    </>
  );
}

